import {EditableLabelWrapping} from 'shells/editable-label/editable-label-wrapping';

import type {PeepType} from '../../../types';

interface Props {
    entityType: PeepType;
    value: string;
    onSaveNewValue: (value: string) => Promise<any>;
}

export function PeepDescriptionContainer(props: Props) {
    return (
        <div className='font-size-normal pl-4 pt-4 pr-4'>
            <EditableLabelWrapping
                value={props.value}
                onSaveNewValue={props.onSaveNewValue}
                placeholder='Add description…'
                allowSavingEmpty={true}
                disableOnSaving={true}
                shouldFocusOnMount={false}
                shouldSaveOnEnter={true}
                showPlaceholderWhenEmpty={true}
                onFocusedOnMount={() => {}}
                // Avoids a tiny jump when the input is selected
                customStyle={{paddingBottom: 0}}
            />
        </div>
    );
}
